/*配置参数分为公共配置参数CommonConfig，生产环境测试服环境TestServerConfig，生产环境正式服环境OnlineServerConfig*/

let IsDevMode =true;                                //通过改变这个变量的值判断导出测试服/正式服的配置参数;正式服的时候改成false
let BaseConfig

const CommonConfig = {
  
  DEV_API: '/DEV_API',                                 //开发环境api地址前缀
  DEV_WS_URL: 'wss://api.dingdanyu.com:7272',          //开发环境websocket地址前缀
  TokenPass: [                                         //不需要加token和needType参数的请求路径
    '/pc/Reglogin/getWechatJsConfig',                  //获取微信配置地址
    '/pc/Reglogin/mobileCodeLogin',                    //手机验证码登录
    '/pc/Reglogin/login',                              //密码登录
    '/pc/Reglogin/ResetPassword',                      //重置密码申请
    '/pc/Reglogin/GetLoginCode',                       //获取手机验证码
  ],
  AlertPass: [                                         //不弹框提示axios请求得到的返回码数组
    '00000',                                           //获取数据成功
    '99999',                                           //未查询到相关数据
    '10000',                                           //用户名或密码错误
    '10042',                                           //获取微信菜单栏配置时地址未注册d
    '10009',                                           //未绑定微信，此时需要直接获取绑定微信二维码
    '10008',                                           //认证未通过
    '10006',                                           //登陆过期信息
    '60000',                                           //身份认证不合法或已过期
    '60001',                                           //token为空
    '10088',                                           //手机号已被占用
    '10111',                                           //认证信息正在审核中
    '10110',                                           //认证信息审核已通过
    '10188',                                           //帐号或密码错误超过3次，限制登录5分钟
    '10286',                                           //连续错误5次会被限制登录5分钟，当前已第3次
    '31062',                                           //订单已经在确认期间
    '10257'                                            //企业帐号不合法
  ]
}

const TestServerConfig = {
  QINIU_URL: 'https://cdn.yudingdan.cn/',                    //七牛云地址前缀
  API_URL:   'https://api.yudingdan.cn',                     //测试服api地址前缀
  WS_URL:    'wss://api.yudingdan.cn:7272',                  //测试服websocket地址前缀
  PC_URL:    'http://www.yudingdan.cn',                      //测试服PC网址
  H5_URL:    'http://m.yudingdan.cn'                         //测试服手机端网址
};
const OnlineServerConfig = {
  QINIU_URL: 'https://cdn.dingdanyu.com/',                  //七牛云地址前缀
  API_URL:   'https://api.dingdanyu.com',                   //正式服api地址前缀
  WS_URL:    'wss://api.dingdanyu.com:7272',                //正式服websocket地址前缀
  PC_URL:    'http://www.dingdanyu.com',                    //正式服PC网址
  H5_URL:    'https://m.dingdanyu.com'                      //正式服手机端网址
}
//开发模式和生产模式使用不同的配置
if (IsDevMode) {
  BaseConfig = {
    ...CommonConfig,
    ...TestServerConfig,
    IsDevMode:IsDevMode
  }
} else {
  BaseConfig = {
    ...CommonConfig,
    ...OnlineServerConfig,
    IsDevMode:IsDevMode
  }
}

export default BaseConfig
